module.exports = __webpack_public_path__ + "img/firefox-icon.b086bab5.png";